import { httpApi } from "./http.api";

export const getPipelineData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/pipeline/").then((data: any) => data.data);

export const deletePipeline = async (id: number): Promise<any> => {
  return httpApi.delete<any>(`hiring/pipeline/${id}/`, {});
};

export const addPipeline = (pipelinePayload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/pipeline/", { ...pipelinePayload })
    .then(({ data }) => data);

export const importCandidateToPipeline = (pipelinePayload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/custom-pipeline/import-candidate-to-pipeline/", {
      ...pipelinePayload,
    })
    .then(({ data }) => data);

export const getPipeline = (id: number): Promise<any[]> =>
  httpApi
    .get<any[]>("hiring/pipeline/" + id + "/")
    .then((data: any) => data.data);

export const updatePipeline = (
  pipelineId: any,
  pipelinePayload: any
): Promise<any> => {
  delete pipelinePayload.id;
  return httpApi
    .put<any>("hiring/pipeline/" + pipelineId + "/", { ...pipelinePayload })
    .then(({ data }) => data);
};

export const addCandidateToPipeline = (pipelinePayload: any): Promise<any> => {
  return httpApi
    .post<any>("hiring/custom-pipeline/add-candidate-to-pipeline/", {
      ...pipelinePayload,
    })
    .then(({ data }) => data);
};
